// extracted by mini-css-extract-plugin
module.exports = {"PageContainer":"Layout_PageContainer__2bUwL","contentContainer":"Layout_contentContainer__L9HRa"};